module.exports = __webpack_public_path__ + "static/media/b1.e80dd7e7.jpg";